export default __webpack_public_path__ + "static/gradient-sunset-blood-2b27b6e822ccb47ff6e6726cb7b6ad61.png";